export interface FirestoreListenerDiagnosticInput {
  listener: string;
  path: string;
  error: unknown;
  context?: Record<string, unknown>;
}

export interface FirestoreListenerDiagnostic {
  listener: string;
  path: string;
  code?: string;
  message: string;
  context?: Record<string, unknown>;
}

function getStringProp(value: unknown, prop: "code" | "message"): string | undefined {
  if (!value || typeof value !== "object" || !(prop in value)) return undefined;
  const propValue = (value as Record<string, unknown>)[prop];
  return typeof propValue === "string" ? propValue : undefined;
}

export function buildFirestoreListenerDiagnostic({
  listener,
  path,
  error,
  context,
}: FirestoreListenerDiagnosticInput): FirestoreListenerDiagnostic {
  const code = getStringProp(error, "code");
  const message =
    getStringProp(error, "message") ??
    (typeof error === "string" ? error : "Unknown Firestore listener error");

  return {
    listener,
    path,
    ...(code ? { code } : {}),
    message,
    ...(context ? { context } : {}),
  };
}

export function logFirestoreListenerError(input: FirestoreListenerDiagnosticInput): void {
  const diagnostic = buildFirestoreListenerDiagnostic(input);
  const codeLabel = diagnostic.code ? ` (${diagnostic.code})` : "";
  console.error(
    `[Firestore listener] ${diagnostic.listener} failed at ${diagnostic.path}${codeLabel}: ${diagnostic.message}`,
    diagnostic,
    input.error,
  );
}
